interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
  spinnerColor?: string;
  width?: number;
  height?: number;
}

export const LoadingOverlay = ({
  isVisible,
  message,
  spinnerColor = "border-pk-white",
  width = 32,
  height = 32,
}: LoadingOverlayProps) => {
  if (!isVisible) return null;

  return (
    <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center bg-black/30 backdrop-blur-md z-50 rounded-lg">
      <div
        className={`animate-spin rounded-full border-4 ${spinnerColor} border-t-transparent `}
        style={{ width: `${width}px`, height: `${height}px` }}
      ></div>
      {message && (
        <span className="text-pk-white font-semibold text-lg mt-4">
          {message}
        </span>
      )}
    </div>
  );
};
